import { useMemo } from 'react';
import { GRID_PAGE_SIZE, GRID_PER_PAGE_DEFAULT } from 'domain/documents/constants';
import useAgGridRtlMethods from 'components/AgGrid/hooks/useAgGridRtlMethods';

const useAgGridProps = () => {
  const { enableRtl } = useAgGridRtlMethods();

  return useMemo(
    () => ({
      debug: false,
      rowModelType: 'serverSide',
      maxBlocksInCache: 1,
      rowHeight: 72,
      masterDetail: true,
      isRowMaster: () => true,
      detailCellRenderer: 'beneficiaryDetailCellRenderer',
      detailRowAutoHeight: true,
      // Grid default is off; the editable withholding-tax / valid-until column types opt into
      // singleClickEdit individually (see useAgGridColumnTypes) so only those cells edit on one click.
      singleClickEdit: false,
      stopEditingWhenCellsLoseFocus: true,
      suppressServerSideFullWidthLoadingRow: true,
      suppressContextMenu: true,
      suppressScrollWhenPopupsAreOpen: true,
      columnMenu: 'legacy',
      animateRows: false,
      columnHoverHighlight: false,
      suppressMaxRenderedRowRestriction: true,
      suppressMenuHide: true,
      suppressScrollOnNewData: false,
      suppressColumnMoveAnimation: true,
      suppressMultiSort: true,
      suppressMoveWhenColumnDragging: true,
      suppressNavigable: true,
      suppressMovable: true,
      // Cells must be focusable so inline editing (single click / Enter) works on editable columns.
      suppressCellFocus: false,
      tooltipShowDelay: 0,
      scrollbarWidth: 8,
      alwaysShowHorizontalScroll: true,
      alwaysShowVerticalScroll: true,
      selectionColumnDef: {
        pinned: enableRtl ? 'right' : 'left',
        lockPosition: enableRtl ? 'right' : 'left',
        lockPinned: true,
      },
      defaultColDef: {
        filter: true,
        menuTabs: ['filterMenuTab'],
        suppressMovable: true,
        resizable: true,
        minWidth: 120,
        flex: 1,
        headerComponentParams: {
          enablePinning: false,
        },
      },
      pagination: true,
      paginationPageSize: GRID_PER_PAGE_DEFAULT,
      paginationPageSizeSelector: GRID_PAGE_SIZE,
      enableRtl,
    }),
    [enableRtl],
  );
};
export default useAgGridProps;
